export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-redpipe.vue?vue&type=template&id=16a2531a"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-redpipe.vue?vue&type=template&id=16a2531a
// module id = jLKB
// module chunks = 0